/**
 * @fileoverview gRPC-Web generated client stub for qowner.erp.api.v1.services
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.20.3
// source: projects/erp/service/api/v1/services/cities.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

var projects_erp_service_api_v1_model_city_pb = require('./city_pb.js')
const proto = {};
proto.qowner = {};
proto.qowner.erp = {};
proto.qowner.erp.api = {};
proto.qowner.erp.api.v1 = {};
proto.qowner.erp.api.v1.services = require('./cities_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.CitiesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.qowner.erp.api.v1.services.CitiesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ListCitiesRequest,
 *   !proto.qowner.erp.api.v1.services.ListCitiesResponse>}
 */
const methodDescriptor_Cities_ListCities = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Cities/ListCities',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ListCitiesRequest,
  proto.qowner.erp.api.v1.services.ListCitiesResponse,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ListCitiesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.qowner.erp.api.v1.services.ListCitiesResponse.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ListCitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.services.ListCitiesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.services.ListCitiesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CitiesClient.prototype.listCities =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/ListCities',
      request,
      metadata || {},
      methodDescriptor_Cities_ListCities,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ListCitiesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.services.ListCitiesResponse>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CitiesPromiseClient.prototype.listCities =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/ListCities',
      request,
      metadata || {},
      methodDescriptor_Cities_ListCities);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.GetCityRequest,
 *   !proto.qowner.erp.api.v1.model.City>}
 */
const methodDescriptor_Cities_GetCity = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Cities/GetCity',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.GetCityRequest,
  projects_erp_service_api_v1_model_city_pb.City,
  /**
   * @param {!proto.qowner.erp.api.v1.services.GetCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_city_pb.City.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.GetCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.City)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.City>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CitiesClient.prototype.getCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/GetCity',
      request,
      metadata || {},
      methodDescriptor_Cities_GetCity,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.GetCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.City>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CitiesPromiseClient.prototype.getCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/GetCity',
      request,
      metadata || {},
      methodDescriptor_Cities_GetCity);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.qowner.erp.api.v1.services.ApplyCityRequest,
 *   !proto.qowner.erp.api.v1.model.City>}
 */
const methodDescriptor_Cities_ApplyCity = new grpc.web.MethodDescriptor(
  '/qowner.erp.api.v1.services.Cities/ApplyCity',
  grpc.web.MethodType.UNARY,
  proto.qowner.erp.api.v1.services.ApplyCityRequest,
  projects_erp_service_api_v1_model_city_pb.City,
  /**
   * @param {!proto.qowner.erp.api.v1.services.ApplyCityRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  projects_erp_service_api_v1_model_city_pb.City.deserializeBinary
);


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyCityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.qowner.erp.api.v1.model.City)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.qowner.erp.api.v1.model.City>|undefined}
 *     The XHR Node Readable Stream
 */
proto.qowner.erp.api.v1.services.CitiesClient.prototype.applyCity =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/ApplyCity',
      request,
      metadata || {},
      methodDescriptor_Cities_ApplyCity,
      callback);
};


/**
 * @param {!proto.qowner.erp.api.v1.services.ApplyCityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.qowner.erp.api.v1.model.City>}
 *     Promise that resolves to the response
 */
proto.qowner.erp.api.v1.services.CitiesPromiseClient.prototype.applyCity =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/qowner.erp.api.v1.services.Cities/ApplyCity',
      request,
      metadata || {},
      methodDescriptor_Cities_ApplyCity);
};


module.exports = proto.qowner.erp.api.v1.services;

